function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.174 3.9C15.701-.57 8.424-.57 3.951 3.9c-4.474 4.47-4.474 11.74 0 16.21a11.454 11.454 0 008.116 3.35c2.943 0 5.875-1.12 8.117-3.35 4.464-4.47 4.464-11.74-.01-16.21zm-.84 15.36c-4.004 4-10.52 4-14.523 0s-4.003-10.51 0-14.51c2.002-2 4.634-3 7.266-3 2.633 0 5.265 1 7.267 3 3.993 4 3.993 10.51-.01 14.51z",
  fill: "#7F63FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.162 11.4h-4.494V6.91c0-.33-.27-.6-.6-.6-.33 0-.601.27-.601.6v4.49H6.973c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h4.494v4.49c0 .33.27.6.6.6.33 0 .6-.27.6-.6V12.6h4.495c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6z",
  fill: "#7F63FF"
});

function SvgSubmitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "d64e79c3b0ae9c1fe8bf7acb66aeccb8.svg";
export { SvgSubmitted as ReactComponent };